import { useSelector } from 'react-redux'
import { IRootState } from '../../../store'
import Grid from '../../../components/grid/Grid.component'
import React from 'react'
import ZModal from '../../../components/modal/Modal.component'
import ekg from '../../timeline/data/ekgImage.jpg'
import meds from '../../timeline/data/meds.png'
import './timelineSection.component.css'
import { IPHIComponent } from '../../../components/phi/phi.component'

const TimelineSection: React.FC<IPHIComponent> = (props: IPHIComponent) => {
  const timeline = useSelector((state: IRootState) => state.timeline)
  const { showCameraModal, showMonitorModal, items, filteredItems, isEditMode, editedKeys } = timeline
  const { isPHI } = props

  return (
    <>
      <ZModal showModal={showMonitorModal} imgSource={ekg} />
      <ZModal showModal={showCameraModal} imgSource={meds} />

      <Grid isPHI={isPHI} items={filteredItems ? filteredItems : items} reorder={isEditMode} editedKeys={editedKeys} />
    </>
  )
}

export default TimelineSection
